import React from "react";
import TagInput from "./tagInput";
import { Chip } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Button, CompanyPage, FlashMessage } from "../../../components/common";
import { useSelector, useDispatch } from "react-redux";
import { handleDeleteTag } from "../../../reducers/company/companyMarketingSolution.reducer";
import { rootReducersState } from "../../../reducers";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import appRoutes from "../../../routes/app.routes";

const AddTags = () => {
  const tags = useSelector(
    ({ company }: rootReducersState) => company.companyMarketingSolution.tags
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );
  const companySlug = sessionReducer.currentCompany.slug;
  const hasTags = !_.isEmpty(tags);

  const handleContinue = () => {
    if (!hasTags) {
      FlashMessage("Please add at least one tag to continue", "error");
      return;
    }
    navigate(appRoutes.reviewInfo.generatePath(companySlug));
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <CompanyPage
      className="page-marketing"
      title="Add tags"
      subtitle="Group these contacts so you can target them in campaigns."
      footer={
        <>
          <CompanyPage.FooterActions>
            <Button type="button" variant="outlined" onClick={handleBack}>
              Back
            </Button>
            <Button type="button" disabled={!hasTags} onClick={handleContinue}>
              Continue
            </Button>
          </CompanyPage.FooterActions>
        </>
      }
    >
      <TagInput />
      <div
        className={`custom-tags-wrapper${
          tags.length === 0 ? " is-empty" : ""
        }`}
      >
        {tags.length === 0 ? (
          <p className="tags-empty-hint">
            No tags added yet. Add your first tag above.
          </p>
        ) : (
          tags.map((tag: string, index: number) => (
            <Chip
              key={`${tag}-${index}`}
              label={tag}
              variant="outlined"
              onDelete={() => dispatch(handleDeleteTag(tag))}
              deleteIcon={<CloseIcon />}
              className="tag"
            />
          ))
        )}
      </div>
    </CompanyPage>
  );
};

export default AddTags;
